import Stack from "@mui/material/Stack";

import { ExecutionPanelConversation } from "./ExecutionPanelConversation";
import { useExecutionPanelContext } from "./ExecutionPanelContext";
import { AiDisclaimer } from "@src/features/ai/components/WorkflowEditor/execution/components/AiDisclaimer";
import { UserInput } from "@src/features/ai/components/WorkflowEditor/execution/input/UserInput";
import { DropZoneRef } from "@src/features/ai/components/WorkflowEditor/execution/types";

export const ExecutionPanelChat = () => {
  const { getSlot, dropZoneRef } = useExecutionPanelContext();
  return (
    <Stack
      ref={dropZoneRef as DropZoneRef<HTMLDivElement>}
      sx={{
        position: "relative",
        flexGrow: 1,
        minHeight: 0,
      }}
    >
      {getSlot("chatHeader")}
      <ExecutionPanelConversation />
      {getSlot(
        "chatFooter",
        <>
          {getSlot("chatBanner")}
          {getSlot("userInput", <UserInput />)}
          {getSlot("disclaimer", <AiDisclaimer />)}
        </>
      )}
    </Stack>
  );
};
